import React, { useState } from "react";
import { axiosSalary } from "../api/axiosInstance";
import { useAuth } from "../auth/AuthContext";

const BulkManagerSessionEntry = ({
  open,
  onClose,
  employees,
  restId,
  attendanceDate,
  onSuccess
}) => {

  const { user } = useAuth();

  const [reason, setReason] = useState("");
  const [inTime, setInTime] = useState("");
  const [outTime, setOutTime] = useState("");

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {

    if (!inTime || !outTime) {
      alert("Enter In & Out time");
      return;
    }

    if (new Date(outTime) <= new Date(inTime)) {
      alert("Out must be greater than In");
      return;
    }

    try {

      const payload = {
        groupId: user?.groupId,
        restId: restId,
        attendanceDate: new Date(attendanceDate).toISOString(),
        userId: user?.userId,
        reason: reason,

        employees: employees.map(emp => ({
          empId: emp.empId,
          sessions: [
            {
              sessionId: "",
              inTimeIst: new Date(inTime).toISOString(),
              outTimeIst: new Date(outTime).toISOString()
            }
          ]
        }))
      };

      await axiosSalary.post(
        "/ManagerAttendanceEntry/BulkManagerSessionEntry",
        payload
      );

      alert("Bulk session added successfully");

      onClose();
      onSuccess && onSuccess();

    } catch (err) {
      console.error(err);
      alert("Failed bulk entry");
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">

      <div className="bg-white p-4 rounded-lg w-[350px]">

        <h3 className="font-semibold mb-2">
          Bulk Add Session ({employees.length} Employees)
        </h3>

        <input
          type="datetime-local"
          value={inTime}
          onChange={(e) => setInTime(e.target.value)}
          className="w-full border p-2 rounded mb-2"
        />

        <input
          type="datetime-local"
          value={outTime}
          onChange={(e) => setOutTime(e.target.value)}
          className="w-full border p-2 rounded mb-2"
        />

        <textarea
          placeholder="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="w-full border p-2 rounded mb-2"
        />

        <div className="flex justify-end gap-2">

          <button onClick={onClose} className="border px-3 py-1 rounded">
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-3 py-1 rounded"
          >
            Save
          </button>

        </div>

      </div>

    </div>
  );
};

export default BulkManagerSessionEntry;